
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EmailLoginService {

    AppUrl = '';
    constructor(private readonly _http: HttpClient) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
            this.AppUrl = sessionStorage.getItem('BaseURL') || '';
        }
    }

    DecryptEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/DecryptEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidBriefingEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidBriefingEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(() => error.status);
    }

    isValidPriceQuoteEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidPriceQuoteEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidOnboardingQuoteEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidOnboardingQuoteEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidRMDEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidRMDEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidIPCSEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidIPCSEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidVoipEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidVoipEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidWirelessEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidWirelessEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }

    isValidTracItEmailKey(filterModel: any): Observable<any> {
        this.setAPIUrl();
        const url = this.AppUrl + 'api/EmailLogin/IsValidTracitEmailKey';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        return this._http.post<any>(url, filterModel, httpOptions)
            .pipe(catchError(this.handleError));
    }
}
